import PropTypes from 'prop-types';

import useMenus from 'providers/menuMaker/Menus/useMenus';

import Box from '@mui/material/Box';

import RowMenu from './RowMenu';
import HelperSkeleton from './HelperSkeleton';
import useStyles from './styles';

function MenuMakerResumeTable({ menus, loadingPagination, openDrawer, scrollPaginationRef }) {
  const classes = useStyles();
  const { getMenusDetails, menusDetails } = useMenus();

  function handleLoadMenuDetails(menuUuid, categoryUuid) {
    getMenusDetails({ menuUuid, categoryUuid });
  }

  return (
    <Box className={classes.rootTable}>
      {menus?.map((menu, index) => (
        <RowMenu
          details={menusDetails[menu?.uuid]}
          key={menu?.uuid}
          menu={menu}
          onLoadDetails={handleLoadMenuDetails}
          openDefault={index === 0}
          openDrawer={openDrawer}
        />
      ))}
      {loadingPagination && <HelperSkeleton />}

      <Box id="actionTableResumeScroll" mb={4} name="actionTableResumeScroll" ref={scrollPaginationRef} />
    </Box>
  );
}

MenuMakerResumeTable.propTypes = {
  menus: PropTypes.array,
  loadingPagination: PropTypes.bool,
  openDrawer: PropTypes.bool,
  scrollPaginationRef: PropTypes.object,
};

export default MenuMakerResumeTable;
